import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "left-filter-section" };
const _hoisted_2 = { class: "right-filter-section" };
const _hoisted_3 = { class: "info-text brg-color-grey-600" };
const _hoisted_4 = { class: "body1-text" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Select = _resolveComponent("Select");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_SearchInput = _resolveComponent("SearchInput");
    const _component_SearchInputWrapper = _resolveComponent("SearchInputWrapper");
    const _component_SubControllerTemplate = _resolveComponent("SubControllerTemplate");
    const _directive_btn_style = _resolveDirective("btn-style");
    return (_openBlock(), _createBlock(_component_SubControllerTemplate, null, {
        toolsSlot: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_Select, {
                    value: _ctx.getterShareInfoStatusType,
                    class: "status-wrapper",
                    title: _ctx.localeInfo.statusSelectorTitle,
                    items: _ctx.excludeDeleteHubStatusOptionList,
                    "on-change": _ctx.handleChangeSelect('shareInfoStatusType')
                }, null, 8 /* PROPS */, ["value", "title", "items", "on-change"]),
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: _ctx.handleClickResetButton }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                                _createTextVNode(" mdi-restart ")
                            ])),
                            _: 1 /* STABLE */,
                            __: [0]
                        }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.localeInfo.resetButtonText), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            info: true,
                            "size-l": true,
                            outlined: true
                        }
                    ]
                ])
            ]),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_v_icon, {
                        start: "",
                        size: "24"
                    }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createTextVNode(" mdi-information-outline ")
                        ])),
                        _: 1 /* STABLE */,
                        __: [1]
                    }),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.localeInfo.subControllerInfo), 1 /* TEXT */)
                ]),
                _createVNode(_component_SearchInputWrapper, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_SearchInput, {
                            outlined: "",
                            class: "search-text-field",
                            placeholder: _ctx.localeInfo.searchPlaceholder,
                            "on-search": _ctx.handleSearch,
                            "default-value": _ctx.getterSearchWordValue
                        }, null, 8 /* PROPS */, ["placeholder", "on-search", "default-value"])
                    ]),
                    _: 1 /* STABLE */
                })
            ])
        ]),
        _: 1 /* STABLE */
    }));
}
